import { SurfaceBlockSchema } from '@blocksuite/hive/blocks/surface';
import { BlockService } from '@blocksuite/hive/std';

export class MindmapSurfaceBlockService extends BlockService {
  static override readonly flavour = SurfaceBlockSchema.model.flavour;
}
